<div class="flex min-h-screen flex-col bg-gray-50 dark:bg-gray-900">
  <app-header #header />
  <main class="flex flex-col flex-grow py-4">
    <router-outlet />
  </main>
  <app-footer />
  <hlm-toaster [position]="'top-center'" [duration]="6000" [closeButton]="true" />
</div>
